export default __webpack_public_path__ + "static/media/prize-badge.71a00f5b.svg";